module.exports = __webpack_public_path__ + "img/microphone-stand.30cd9172.svg";